import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
    parseLanguageFromPathname,
    useLocalization,
} from "../stores/localizationContext";

/** Keeps localization context in sync with the language segment in the URL. */
export function LocalizationUrlSync() {
    const { pathname } = useLocation();
    const { lang, setLanguage } = useLocalization();

    useEffect(() => {
        const urlLang = parseLanguageFromPathname(pathname);
        if (urlLang !== lang) {
            void setLanguage(urlLang);
        }
    }, [pathname, lang, setLanguage]);

    return null;
}
